import { Component, OnInit, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { AcademyService } from "../academies/service/academies.service";
import { ReportService } from "src/app/services/report.service";
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-subscription',
  templateUrl: './user-subscription.component.html',
  styleUrls: ['./user-subscription.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserSubscriptionComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  userSubscriptionData: any;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  searchby;
  public hide: boolean = true;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  academiesList: any;
  academyTournamentsList: any;
  country: any;
  state: any;
  cityName: any;
  sportName: any;
  academyId: any;
  downloadUserSubscriptionDataList: any;

  constructor(
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private categoryService: CategoryService,
    private academyService: AcademyService,
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Subscribed Date', value: "created_at" }
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
    this.getAcademies();
  }

  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    this.stateList = [];
    this.cityList = [];
    this.state = null;
    this.cityName = null;
    if (event.value !== null) {
      let countryCode = event.value.iso2;
      let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
      this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let stateObj = {
              name: element.name,
              id: element.id,
            }
            this.stateList.push(stateObj);
          });
        }
      })
    }
    this.loadUserSubscription(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    this.cityList = [];
    this.cityName = null;
    if (event.value !== null) {
      const stateCode = event.value.id;
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
      this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
    this.loadUserSubscription(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    this.academyId = null;
    this.loadUserSubscription(this.lastTableLazyLoadEvent);
  }

  loadUserSubscription(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.country) {
      params += "&filterByCountry=" + this.country.name;
    }

    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }

    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }

    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getUserSubscriptions(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.userSubscriptionData = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportUserSubscriptionReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadUserSubscription(this.lastTableLazyLoadEvent);
  }

  async exportUserSubscriptionReportListData(userReportList) {
    this.downloadUserSubscriptionDataList = JSON.parse(JSON.stringify(userReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadUserSubscriptionDataList[prop];
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    // Set column widths
    const colWidths = [
      { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 25 },
      { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 35 }
    ];
    worksheet['!cols'] = colWidths;

    // Add parent section with visual separation
    const parentSection = [
      [],
      ["Total Active Subscriptions", "Total Active Subscriptions (Quarterly)", "Total Active Subscriptions (Half Yearly)", "Total Active Subscriptions (Annual)", "Revenue through Monthly Subscription", "Revenue through Half Yearly Subscription", "Revenue through Annual Subscription", "Total TPL Revenue"],
      [this.downloadUserSubscriptionDataList.summary.totalActiveSubscriptions, this.downloadUserSubscriptionDataList.summary.totalActiveSubscriptionsQuarterly, this.downloadUserSubscriptionDataList.summary.totalActiveSubscriptionsHalfYearly, this.downloadUserSubscriptionDataList.summary.totalActiveSubscriptionsAnnual, this.downloadUserSubscriptionDataList.summary.revenueThroughMonthlySubscription, this.downloadUserSubscriptionDataList.summary.revenueThroughHalfYearlySubscription, this.downloadUserSubscriptionDataList.summary.revenueThroughAnnualSubscription, this.downloadUserSubscriptionDataList.summary.totalTPLRevenue],
      [],
      ['Mobile Number', 'Username', 'Age', 'City', 'State', 'Country', 'SubscriptionID', 'Subscribed Date', 'Type of Subscription', 'Renewal Date', 'Registered Academy', 'TPL Revenue', 'GST Amount', 'Academy Commission %', 'Academy Payout', 'TPL Share']
    ];

    XLSX.utils.sheet_add_aoa(worksheet, parentSection, { origin: -1 });

    this.downloadUserSubscriptionDataList['data'].forEach((parent: any) => {
      if (parent.subscribedDate) {
        parent.subscribedDate = moment(parent.subscribedDate).format("DD-MM-YYYY");
      }

      if (parent.renewalDate) {
        parent.renewalDate = moment(parent.renewalDate).format("DD-MM-YYYY");
      }

      XLSX.utils.sheet_add_aoa(worksheet, [
        [
          parent.mobileNumber,
          parent.username,
          parent.age,
          parent.city,
          parent.state,
          parent.country,
          parent.subscriptionId,
          parent.subscribedDate,
          parent.typeOfSubscription,
          parent.renewalDate,
          parent.registeredAcademy,
          parent.tplRevenue,
          parent.gstAmount,
          parent.academyCommissionPercent,
          parent.academyPayout,
          parent.tplShare
        ],
      ], { origin: -1 });
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, "User_Subscription");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([excelBuffer]), "User_Subscription.xlsx");

    this.downloadFlg = false;
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
